import { Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import { Button, DrawerNavBar } from "@platform/design-system";

import { SaveDraftStatus, SaveStatus } from "./SaveDraftStatus";

interface ButtonConfig {
  label: string;
  onClick: VoidFunction;
  loading?: boolean;
  disabled?: boolean;
  tooltip?: string;
}

const DrawerFooter = ({
  onSave,
  saveStatus = "idle",
  lastUpdated,
  primaryButtonConfig,
  secondaryButtonConfig,
}: {
  onSave?: VoidFunction;
  saveStatus?: SaveStatus;
  lastUpdated?: Date;
  primaryButtonConfig: ButtonConfig;
  secondaryButtonConfig: ButtonConfig;
}): React.JSX.Element => (
  <DrawerNavBar bottom>
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexGrow={1}
      gap={2}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <SaveDraftStatus
          status={saveStatus}
          lastUpdated={lastUpdated}
          onSave={onSave}
        />
      </Box>
      <Box>
        <Button
          size="lg"
          variant="tertiary"
          onClick={secondaryButtonConfig.onClick}
          disabled={secondaryButtonConfig.disabled}
        >
          {secondaryButtonConfig.label}
        </Button>
        <Tooltip
          title={primaryButtonConfig.tooltip || ""}
          disableHoverListener={!primaryButtonConfig.tooltip}
          arrow
        >
          <span>
            <Button
              size="lg"
              variant="primary"
              onClick={primaryButtonConfig.onClick}
              loading={primaryButtonConfig.loading}
              disabled={primaryButtonConfig.disabled}
              style={{ display: "inline-block" }}
            >
              {primaryButtonConfig.label}
            </Button>
          </span>
        </Tooltip>
      </Box>
    </Box>
  </DrawerNavBar>
);

export { DrawerFooter, ButtonConfig as DrawerFooterButtonConfig };
